<template>
    <ui-modal>
        <template #header>
            <h3 v-text="`Integracja z operatorem ${ operatorName }`" class="mb-1" />
            <h5 v-text="location.full_name" class="mb-0 text-center" />
        </template>

        <page-preloader v-if="isLoading" min-height="10rem" />

        <div v-else class="card gap-1 p-3">
            <h5>
                Dane do integracji
                <span class='text-danger'>*</span>
            </h5>
            <the-input
                required
                class="cux-exclude col-md-5 text-primary m-0 p-0"
                label="Numer punktu zbiórki"
                :tooltip="cpIdTooltip"
                :text="form.collectionPointId"
                :mask="cpIdMask"
                :placeholder="cpIdPlaceholder"
                :maxlength="cpIdMaxLength"
                :invalid="cpIdTouched && invalidCpId"
                :invalid-feedback="cpIdFeedback"
                @input="onCpIdInput"
                @blur="onCpIdBlur"
            />

            <the-input
                v-if="isRetailerTokenRequired"
                required
                class="col-md-5 text-primary m-0 p-0"
                label="Token operatora"
                :tooltip="retailerTokenTooltip"
                :text="form.retailerToken"
                :invalid="!form.retailerToken"
                invalid-feedback="To pole nie może być puste"
                @input="onRetailerTokenInput"
            />
        </div>

        <template #footer>
            <the-btn
                text="Zamknij"
                class="btn-outline-custom"
                :disabled="isLoading"
                @click="closeModal"
            />
            <the-btn
                text="Zapisz"
                class="btn-secondary"
                :disabled="isLoading || isFormInvalid"
                @click="confirmExternalDataChanges"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import operatorExternalDataMixin from '@/components/drs/operators/operator-external-data.mixin'

export default {
    mixins: [operatorExternalDataMixin],

    data: () => ({
        isLoading: false,
        cpIdTouched: false,
        initialForm: {},
        form: {
            collectionPointId: '',
            retailerToken: ''
        }
    }),

    created() {
        const form = {
            collectionPointId: this.location.externalData?.collection_point_id || '',
            retailerToken: this.location.externalData?.retailer_token || ''
        }

        this.initialForm = { ...form }
        this.form = { ...form }
    },

    computed: {
        ...mapGetters('drsOperators', ['operatorContract', 'getOperatorById']),
        location() {
            return this.$store.getters.getModal.args?.location || {}
        },

        operator() {
            const operatorServiceId = this.operatorContract?.operatorServiceId
            return this.getOperatorById(operatorServiceId) || {}
        },

        operatorCode() {
            return this.operator?.code
        },

        operatorName() {
            return this.operator?.name || ''
        },

        invalidCpId() {
            return !this.isValidCpId(this.form.collectionPointId)
        },

        hasChanges() {
            return this.form.collectionPointId !== this.initialForm.collectionPointId ||
                this.form.retailerToken !== this.initialForm.retailerToken
        },

        isFormInvalid() {
            return !this.hasChanges ||
                !this.form.collectionPointId ||
                this.invalidCpId ||
                (this.isRetailerTokenRequired && !this.form.retailerToken)
        }
    },

    methods: {
        ...mapActions('drsOperators', ['updateLocationExternalData']),

        onCpIdInput(val) {
            this.form.collectionPointId = val
            this.cpIdTouched = false
        },

        onCpIdBlur() {
            this.cpIdTouched = true
        },

        onRetailerTokenInput(val) {
            this.form.retailerToken = val
        },

        async confirmExternalDataChanges() {
            if (this.isFormInvalid) return

            this.isLoading = true

            try {
                await this.updateLocationExternalData({
                    locationId: this.location.locationId,
                    operatorServiceId: this.operatorContract.operatorServiceId,
                    collectionPointId: this.form.collectionPointId,
                    retailerToken: this.form.retailerToken
                })

                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Numer punktu zbiórki zapisany poprawnie'
                })
            } catch (error) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Przy zapisie numeru punktu zbiórki wystąpił błąd'
                })
                console.error(error)
            } finally {
                this.closeModal()
                this.isLoading = false
            }
        },

        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>
